import { fromJS } from 'immutable';
import { getViewInitialState } from 'src/store/view/reducer';
import { INIT_APP } from '../../../../store/view/constants';
import {
  TOGGLE_MAP,
  ROUTE_TRANSITION_START,
  ROUTE_TRANSITION_END,
  EXPAND_TOURIST_FORM,
  SET_TOPBAR_INDEX,
  TOGGLE_TOPBAR,
  SCROLL_POSITION,
  RESET_SCROLL_POSITION,
  TOGGLE_FILTERS_PANEL,
  SET_INITIAL_OPENED_FIELD,
} from '../constants/view';
import { CHANGE_SELECTED_FLIGHT_CLASS } from '../../CheckoutRoutes/PackageCheckout/store/flights/constants';
import { CLEAR_PREVIOUS_PACKAGE_DATA } from '../constants/similar-packages';
import { DEFAULT_TOPBAR_SLIDE } from '../../../../constants';
import {
  setFlightsProgressBarIsSticky,
  setShowSummaryAction,
  shrinkTouristFormsAction,
} from '../actions/view';

const initialState = fromJS({ ...getViewInitialState(), activeTouristForm: 0 });

export default function viewReducer(state = initialState, { type, payload }) {
  switch (type) {
    case INIT_APP:
      return state.set('app', payload.appName);
    case TOGGLE_MAP:
      return state.set('isMapExpanded', !state.get('isMapExpanded'));
    case CHANGE_SELECTED_FLIGHT_CLASS:
      return state.set('selectedClass', payload);
    case ROUTE_TRANSITION_START:
      return state.set('isRouteTransition', true);
    case ROUTE_TRANSITION_END:
      return state.set('isRouteTransition', false);
    case EXPAND_TOURIST_FORM:
      return state.set('activeTouristForm', payload);
    case shrinkTouristFormsAction.type:
      return state.set('activeTouristForm', undefined);
    case SET_TOPBAR_INDEX:
      return state.set('topbarIndex', payload);
    case TOGGLE_TOPBAR:
      return state.set('isTopbarExpanded', payload);
    case SCROLL_POSITION:
      return state.set('scrollPosition', payload);
    case RESET_SCROLL_POSITION:
      return state.set('scrollPosition', null);
    case CLEAR_PREVIOUS_PACKAGE_DATA:
      return state.merge({
        isTopbarExpanded: false,
        activeTouristForm: 0,
        topbarIndex: DEFAULT_TOPBAR_SLIDE,
      });
    case TOGGLE_FILTERS_PANEL:
      return state.set('showFiltersModal', !state.get('showFiltersModal'));
    case setFlightsProgressBarIsSticky.type:
      return state.set('flightsProgressBarIsSticky', payload);
    case setShowSummaryAction.type:
      return state.set('showSummary', payload);
    case SET_INITIAL_OPENED_FIELD:
      return state.set('initialOpenedField', payload);
    default:
      return state;
  }
}
